module.exports = __webpack_public_path__ + "static/media/Leopard869_2c.0b83cad2.svg";